import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { ERROR_SAVE_CUSTOM_FIELDS_SERVER } from '@/app/module/custom-fields/definitions'
import { createNotification } from '@/app/module/notifications/store/actions'
import { selectOrgId } from '@/app/module/user/store/selectors'
import { esApi } from '@/app/store/api'
import { useAppDispatch } from '@/app/store/redux-hooks'

export const useUpdateCustomField = () => {
  const dispatch = useAppDispatch()
  const orgId = useSelector(selectOrgId)
  const [update, res] = esApi.endpoints.updateOrgCustomfield.useMutation()

  const updateCustomField = useCallback(
    async (id: number, name: string) => {
      try {
        const result = await update({
          orgId: orgId.toString(),
          customfieldId: id.toString(),
          body: { name },
        }).unwrap()

        dispatch(
          createNotification({
            'update-custom-field-success': {
              type: 'success',
              message: `Custom field "${name}" was successfully saved`,
            },
          }),
        )

        return result
      } catch {
        dispatch(
          createNotification({
            'update-custom-field-failure': {
              type: 'error',
              message: ERROR_SAVE_CUSTOM_FIELDS_SERVER,
            },
          }),
        )

        return undefined
      }
    },
    [orgId, dispatch, update],
  )

  return [updateCustomField, res] as const
}
